import axios from "axios";
import React, {Component} from "react";
import Select from 'react-select';
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import { toast } from "react-toastify";
class   ParentfamilyForm extends Component{

    state = {
        id : "",
        user : "",
        matricule : null,
        first_name : "",
        last_name : "",
        family_name : "",
        genre : "Masculin",
        profession : "",
        email : "",
        tel : null,
        identity_number : null,
        title : "",
        password : "",
        yearId : null,
        userId : "",
        years : [],
        profileId : "",
        responsible : "",
        responsibles : [],
        profiles : [],
        error : "",
    }

    handleInput = (e) => {
        this.setState({
            userId : null,
            [e.target.name]: e.target.value
        }); 
    }

    storeParentfamily = () =>{
        var data = {
            profileId : this.state.profileId || '1dbd92ac-b85e-4c66-9281-9c16426f1f64',
            userId : this.state.userId,
            matricule : this.state.matricule ? this.state.matricule : null,
            first_name : this.state.first_name,
            adress : this.state.adress,
            last_name : this.state.last_name,
            family_name : this.state.family_name,
            genre :  this.state.genre,
            profession : this.state.profession,
            email : this.state.email ? this.state.email : null,
            tel : this.state.tel ? this.state.tel : null,
            identity_number : this.state.identity_number ? this.state.identity_number : null,
            operation : this.state.id ? "Editer" : "Ajouter",
            yearId : this.state.yearId > 0 ? this.state.yearId : null,
            password :  "123"
        }

        var request = this.state.id ? axios.put('parentfamilies/'+this.state.id, data) : axios.post('parentfamilies', data);
        request.then((response) =>{
            this.props.showModal(response.data?.data || null, true)
            this.form()
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg
            })
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    async profiles(){
        var request = await axios.get('profiles');
        if(request.status === 200)
            this.setState({profiles : request.data})
            request.data.map((profile) => {
                if(profile.model == "Parentfamily")
                    this.setState({ profileId : profile.id})
            });
    }

    async responsibles(){
        var request = await axios.get('staffs');
        if(request.status === 200)
            this.setState({responsibles : request.data})
    }

    async getYear(){
        var data=[], years = await axios.get('years');
        
        if(years.status === 200)
        {
            years.data.map((year) => {
                data.push({value : year.id, label : year.year})
            })
            
            this.setState({
                years : data
            })
        }
    }

    edit=()=>  {
        this.profiles()
        this.form()
        // this.getYear();
        this.responsibles()
    }

    form=()=>{
        this.setState({
            id : this.props.formData ? this.props.formData.id : "",
            matricule : this.props.formData ? this.props.formData.user ? this.props.formData.user?.matricule : "" : "",
            adress : this.props.formData ? this.props.formData.user ? this.props.formData.user?.adress : "" : "",
            first_name : this.props.formData ? this.props.formData.user ? this.props.formData.user?.first_name : "" : "",
            last_name : this.props.formData ? this.props.formData.user ? this.props.formData.user?.last_name : "" : "",
            family_name : this.props.formData ? this.props.formData.user ? this.props.formData.user?.family_name : "" : "",
            genre : this.props.formData ? this.props.formData.user ? this.props.formData.user?.genre : "Masculin" : "Masculin",
            profession : this.props.formData ? this.props.formData.user ? this.props.formData.user?.profession : "" : "",
            email : this.props.formData ? this.props.formData.user ? this.props.formData.user?.email : "" : "",
            tel : this.props.formData ? this.props.formData.user ? this.props.formData.user?.tel : "" : "",
            identity_number : this.props.formData ? this.props.formData.user ? this.props.formData.user?.identity_number : "" : "",
            datebirth : this.props.formData ? this.props.formData.user ? this.props.formData.user?.datebirth : "" : "",
            yearId : this.props.formData  ? this.props.formData.user ? this.props.formData.user?.yearId : null : null,
            title : this.props.formData ? "Informations du parent" : "Ajout d'un parent",
            error : "",
        })
    }

    render(){
        var optionresponsibles = [];
        var optionprofiles = [];

        this.state.responsibles.map((responsible) => {
            optionresponsibles.push({value : responsible, label : (responsible?.user?.last_name || '') + "  "+ (responsible?.user?.family_name || '') + "  "+ (responsible?.user?.first_name || '') +" "+(responsible?.user?.tel || '')})
        });
        
        this.state.profiles.map((profile) => {
            if(profile.model == "Parentfamily")
                optionprofiles.push({value : profile.id, label : profile.profile })
        });

        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="student-form-dialog"
                contentClassName="student-form-modal student-form-modal--compact"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <div className="student-form__heading">
                        <span className="student-form__heading-icon"><FeatherIcon icon="users" size="20" /></span>
                        <div>
                            <span className="student-form__eyebrow">Dossier familial</span>
                            <Modal.Title>{ this.state.title}</Modal.Title>
                        </div>
                    </div>
                </Modal.Header>
                    <Modal.Body className="row student-form__body">
                        {this.state.error && <div className="col-12"><div className="student-form__alert" role="alert"><FeatherIcon icon="alert-circle" size="17" /><span>{this.state.error}</span></div></div>}

                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="link" size="15" /></span>
                            <div>
                                <strong>Personnel associé</strong>
                                <small>Réutilisez les informations d'un membre du personnel si nécessaire.</small>
                            </div>
                        </div>
                        <div className="form-group col-md-12 mt-2">
                            <label>Parmi le personnel</label>
                            <div className="input-group">
                                <Select
                                    className="form-control form-control-sm p-0"
                                    value = {
                                        optionresponsibles.filter(option => 
                                        option.value == this.state.responsible)
                                    }
                                    defaultValue={this.state.responsible}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                responsible : select.value,
                                                userId : select.value?.user?.id,
                                                last_name : select.value?.user?.last_name,
                                                first_name : select.value?.user?.first_name,
                                                family_name : select.value?.user?.family_name,
                                                tel : select.value?.user?.tel,
                                                email : select.value?.user?.email,
                                                genre : select.value?.user?.genre,
                                                identity_number : select.value?.user?.identity_number,
                                                yearId : select.value?.user?.yearId,
                                            });
                                        }
                                    }
                                    options={optionresponsibles}
                                />
                            </div>
                        </div>

                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="user" size="15" /></span>
                            <div>
                                <strong>Informations personnelles</strong>
                                <small>Identité et coordonnées du parent ou responsable.</small>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="nom-id-icon">Nom <span className="text-danger">*</span></label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="last_name"  value={this.state.last_name} id="nom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="prenom-id-icon">Prénom </label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="first_name"  value={this.state.first_name} id="prenom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="postnom-id-icon">Post-nom </label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="family_name"  value={this.state.family_name} id="postnom-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="email-id-icon">Email </label>
                                <div className="position-relative mt-1">
                                    <input type="email" className="form-control form-control-sm"  onChange={this.handleInput} name="email"  value={this.state.email} id="email-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="mail"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="identity-number-id-icon">N° d'identité</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="identity_number"  value={this.state.identity_number} id="identity-number-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="trello"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="telephone-id-icon">N° de téléphone <span className="text-danger">*</span></label>
                                <div className="position-relative mt-1">
                                    <input type="number" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="tel"  value={this.state.tel} id="telephone-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="phone-call"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="adresse-id-icon">Adresse</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="adress"  value={this.state.adress} id="adresse-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="flag"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-6 mt-2">
                            <div className="form-group has-icon-left">
                                <label htmlFor="profession-id-icon">Profession</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" placeholder=""  onChange={this.handleInput} name="profession"  value={this.state.profession} id="profession-id-icon" />
                                    <div className="form-control-icon text-primary">
                                        <FeatherIcon icon="box"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {/* <div className=" col-md-3 mt-2 d-none">
                            <label className="font-monospace fw-normal">Année scolaire</label>
                            <div className="input-group p-0 m-0">
                                <Select
                                    className="form-control form-control-sm p-0 m-0"
                                    value = {
                                        this.state.years.filter(option => 
                                        option.value == this.state.yearId)
                                    }
                                    defaultValue={this.state.yearId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                yearId : select.value
                                            });
                                        }
                                    }
                                    options={this.state.years}
                                />
                            </div>
                        </div>

                        <div className="form-group col-6 mt-2 d-none">
                            <label className="font-monospace fw-normal">Profile</label>
                            <div className="input-group">
                                <Select
                                    className="form-control form-control-sm p-0"
                                    value = {
                                        optionprofiles.filter(option => 
                                        option.value == this.state.profileId)
                                    }
                                    defaultValue={this.state.profileId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                profileId : select.value,
                                            });
                                        }
                                    }
                                    options={optionprofiles}
                                />
                            </div>
                        </div> */}
                        
                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Genre <span className="text-danger">*</span></label>
                            <div className="ev-choice-group">
                                <label className="ev-choice" htmlFor="student-masculin"><input id="student-masculin" type="radio" name="genre" value="Masculin" checked={this.state.genre === "Masculin"} onChange={this.handleInput} /><span>Masculin</span></label>
                                <label className="ev-choice" htmlFor="student-feminin"><input id="student-feminin" type="radio" name="genre" value="Feminin" checked={this.state.genre === "Feminin"} onChange={this.handleInput} /><span>Féminin</span></label>
                            </div>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <span className="student-form__footer-note"><FeatherIcon icon="info" size="14" /> Vérifiez les coordonnées avant l'enregistrement</span>
                        <button type="button" onClick={this.props.showModal} className="btn btn-light student-form__button"><FeatherIcon icon="x" size="16" /> Fermer</button>
                        <button type="button" onClick={() => this.storeParentfamily()} className="btn btn-primary student-form__button"><FeatherIcon icon="check" size="16" /> Sauvegarder</button>
                    </Modal.Footer>
            </Modal>
            
        </div>
        )
    }
}
export default ParentfamilyForm;
